import React from 'react';
import useEmotionStyles from '../uikit/hooks/useEmotionStyles';
var styles = function (theme) {
    var _a;
    return ({
        root: (_a = {},
            _a['& a'] = {
                fontWeight: 'bold',
                color: theme.palette.primary.main,
            },
            _a),
    });
};
export var Dangerous = function (_a) {
    var html = _a.html;
    var cs = useEmotionStyles(styles);
    return (React.createElement("span", { className: cs.root, dangerouslySetInnerHTML: {
            __html: html,
        } }));
};
